import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface AvelineLogoProps {
    className?: string
    markClassName?: string
    compact?: boolean
}

export const AvelineLogo: FC<AvelineLogoProps> = ({
    className,
    markClassName = 'text-gold-deep',
    compact = false
}): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-3', className)}>
            <svg
                viewBox='0 0 40 40'
                aria-hidden='true'
                className={cn('size-8 shrink-0', markClassName)}
            >
                <circle cx='20' cy='20' r='19' fill='none' stroke='currentColor' strokeOpacity='0.45' />
                <path d='M13 28 L20 11 L27 28' fill='none' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M16.2 22.2 H23.8' fill='none' stroke='currentColor' strokeWidth='1.3' strokeLinecap='round' />
            </svg>

            <span className='flex flex-col leading-none'>
                <span className='font-heading text-[1.4rem] font-medium tracking-[0.32em]'>
                    AVELINE
                </span>

                {!compact && (
                    <span className='mt-1 text-[0.55rem] uppercase tracking-[0.48em] opacity-60'>
                        Paris · 1908
                    </span>
                )}
            </span>
        </span>
    )
}
